import React, {Component} from 'react';
import LoginThirdBtn from "../LoginThirdBtn";
import LoginWorkWechatCode from "../LoginWorkWechatCode";
import './index.css'

class LoginWorkWechat extends Component {
    render() {
        const {changeContModePage, customLoginConfig} = this.props;
        const modeBtnShow={
            dingdingShow:true,
            workWechatShow:false,
            qyWechatShow:true,
            feishuShow:true,
            qyzjWechatShow:true,
            wechatShow:true,
            LoginAccountPasswordShow: true,
            LoginCodeShow: true,
            ssoShow: true,
        }
        return (
            <div className="LoginWorkWechat">
                <div className="loginContentBox">
                    <div className="title">
                        {React.language('account.signin.wechat')}
                    </div>
                    <LoginWorkWechatCode />
                </div>
                <LoginThirdBtn modeBtnShow={modeBtnShow} customLoginConfig={customLoginConfig} changeContModePage={changeContModePage} />
            </div>
        );
    }
}

export default LoginWorkWechat;